export default {
  SET_MINIMIZED({ commit }, payload) {
    commit('SET_MINIMIZED', payload);
  },
  SET_PINNED({ commit }, payload) {
    commit('SET_PINNED', payload);
  },
  SET_MOUSEOVER({ commit }, payload) {
    commit('SET_MOUSEOVER', payload);
  },
  SET_AUTOMATIC({ commit }, payload) {
    commit('SET_AUTOMATIC', payload);
  },
};
